module.exports = __webpack_public_path__ + "static/man-o-9572085c0cee8792b579eec99139f1da.jpg";